import api from "./core";

const basePath = "api/portal/SystemSettings";

export default {
  get() {
    return api.get(`${basePath}`);
  }
};
